var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"type":_vm.hasError() ? 'is-danger': '',"message":_vm.errorMessage()}},[_c('b-input',{class:{'is-danger': _vm.hasError()},attrs:{"placeholder":_vm.placeholder,"icon":_vm.icon,"disabled":_vm.disabled},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }